<template>
  <div class="devices">
    <ul class="devices__list">
      <template v-if="devices.length > 0">
        <li
          v-for="device in devices"
          :key="device.id"
          class="devices__list-item"
        >
          <router-link
            :to="{ name: 'device-detail', params: { deviceid: device.id } }"
          >
            <DeviceTeaser
              :device="device"
              :show-clock-when-timer-is-active="true"
            />
          </router-link>
        </li>
      </template>
      <li v-if="devices.length === 0 && teaser">
        <div class="text-content">
          <h2>{{ t('devices.deviceManagerTitle') }}</h2>
          <img
            class="text-content__img-left"
            :src="assetPath('device-types/mystrom-wifi-switch.png')"
          />
          <p>
            {{ t('devices.deviceManagerDescription') }}
          </p>

          <p>
            {{ t('devices.deviceManagerInstallPrefix') }}
            <a
              href="https://mystrom.com/de/wifi-switch"
              target="_blank"
              rel="noopener"
            >
              schaltbare Steckdose <IconExternal />
            </a>
            {{ t('devices.deviceManagerInstallSuffix') }}
          </p>
          
          <LinkButton :text="myStromBuyButtonText" @click.native="toShop" :disabled="!isMyStromDeviceBookable" />

          <div class="spacer"></div>
          <p>{{ t('devices.deviceManagerDetailsTitle') }}</p>
          <ul>
            <li>
              <a
                href="https://efriends.zendesk.com/hc/de/articles/4405385691793"
                target="_blank"
                rel="noopener"
              >{{ t('devices.deviceManagerManualLink') }} <IconExternal
              /></a>
            </li>
            <li>
              <a
                href="https://efriends.zendesk.com/hc/de/articles/4405387558801"
                target="_blank"
                rel="noopener"
              >{{ t('devices.deviceManagerAppLink') }} <IconExternal
              /></a>
            </li>
          </ul>
          <p class="mt">
            {{ t('devices.deviceManagerSummary') }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import DeviceTeaser from '@/components/devices/DeviceTeaser.vue';
import IconExternal from '@/components/icons/External.vue';
import LinkButton from '@/components/LinkButton.vue';
import { useStrings } from '@/composables/useStrings.ts';
import { assetPath } from '@/util'
import { useShopStore } from '@/stores/useShopStore';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

interface Props {
  devices: { id: string }[]
  teaser?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  teaser: true,
})

const { t } = useStrings()
const router = useRouter()
const shopStore = useShopStore()

const toShop = () => router.push({ name: 'shop' })

const isMyStromDeviceBookable = computed(() => {
  const articles = shopStore.bookableArticles
  if (!Array.isArray(articles) || articles.length === 0) { return false }
  return articles.some(article => article.name?.toLowerCase().includes('mystrom'))
})

const myStromBuyButtonText = computed(() => {
  return isMyStromDeviceBookable.value
    ? t('devices.orderSocket')
    : t('devices.socketUnavailable')
})

</script>

<style lang="scss" scoped></style>
<style lang="scss">
  .devices {
    margin-top: $spacer20;

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;

      &-item {
        &:hover,
        &:focus,
        &:active {
          background: rgba(0, 0, 0, 0.03);
        }
      }
    }
  }
  .spacer {
    height: 5rem;
  }
  @media (max-width: 630px) {
    .spacer {
      height: 1rem;
    }
  }
  .mt {
    margin-top: 1rem;
  }
</style>
